import { c as _c } from "react/compiler-runtime";
import parse, { type DOMNode, domToReact, Element, type HTMLReactParserOptions } from "html-react-parser";
import Link from "next/link";
import type { JSX } from "react";
export type ReplacementsMap = Record<string, (domNode: Element, options: HTMLReactParserOptions) => JSX.Element | Element | null>;
interface HtmlParserProps {
  data?: string;
  redefine?: ReplacementsMap;
}
export const HtmlParser = props => {
  const $ = _c(6);
  const {
    data,
    redefine
  } = props;
  let t0;
  let t1;
  if ($[0] !== data || $[1] !== redefine) {
    t1 = Symbol.for("react.early_return_sentinel");
    bb0: {
      let replacementsMap = {};
      replacementsMap.a = _temp;
      replacementsMap.ul = _temp2;
      replacementsMap.ol = _temp3;
      replacementsMap.h2 = _temp4;
      replacementsMap.h3 = _temp5;
      replacementsMap.h4 = _temp6;
      replacementsMap.h5 = _temp7;
      replacementsMap = {
        ...replacementsMap,
        ...redefine
      };
      const options_6 = {
        replace: domNode_6 => {
          if (domNode_6 instanceof Element) {
            if (replacementsMap[domNode_6.name]) {
              return replacementsMap[domNode_6.name](domNode_6, options_6);
            }
            return domNode_6;
          }
        }
      };
      if (!data) {
        t1 = null;
        break bb0;
      }
      t0 = parse(data, options_6);
    }
    $[0] = data;
    $[1] = redefine;
    $[2] = t0;
    $[3] = t1;
  } else {
    t0 = $[2];
    t1 = $[3];
  }
  if (t1 !== Symbol.for("react.early_return_sentinel")) {
    return t1;
  }
  let t2;
  if ($[4] !== t0) {
    t2 = <>{t0}</>;
    $[4] = t0;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  return t2;
};
function _temp(domNode, options) {
  const href = domNode.attribs.href;
  return <Link href={href} className="text-primary-600 font-semibold">{domToReact(domNode.children, options)}</Link>;
}
function _temp2(domNode_0, options_0) {
  return <ul className="pl-8 list-disc">{domToReact(domNode_0.children, options_0)}</ul>;
}
function _temp3(domNode_1, options_1) {
  return <ol className="pl-8 list-decimal">{domToReact(domNode_1.children, options_1)}</ol>;
}
function _temp4(domNode_2, options_2) {
  return <h2 className="my-6 font-bold text-3xl">{domToReact(domNode_2.children, options_2)}</h2>;
}
function _temp5(domNode_3, options_3) {
  return <h3 className="my-6 font-bold text-2xl">{domToReact(domNode_3.children, options_3)}</h3>;
}
function _temp6(domNode_4, options_4) {
  return <h4 className="my-6 font-bold text-xl">{domToReact(domNode_4.children, options_4)}</h4>;
}
function _temp7(domNode_5, options_5) {
  return <h5 className="my-6 font-bold text-lg">{domToReact(domNode_5.children, options_5)}</h5>;
}